import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {Stock} from "../components/model/stock";
import {StockInOut} from "../components/model/stock-in-out";
import { StockResponse, StockHistoryResponse, StockLot } from '../interfaces/stock.interface';

export const StockService = {
    stockIn: async (stock: StockInOut): Promise<Stock> => {
        const response = await axios.patch(ENDPOINTS.STOCK.STOCK_IN, stock);
        return response.data;
    },

    stockOut: async (stock: StockInOut): Promise<Stock> => {
        const response = await axios.patch(ENDPOINTS.STOCK.STOCK_OUT, stock);
        return response.data;
    },

    getStockByStoreAndItem: async (storeId: string, itemId: string): Promise<Stock> => {
        const response = await axios.get(`${ENDPOINTS.STOCK.STOCK_BY_STORE_AND_ITEM(storeId, itemId)}`);
        return response.data;
    },

    getStockByStore: async (storeId: string, page: number = 0, size: number = 10, search: string = ''): Promise<StockResponse> => {
        const response = await axios.get(`${ENDPOINTS.STOCK.STOCK_BY_STORE(storeId)}?page=${page}&size=${size}&search=${encodeURIComponent(search)}`);
        return response.data;
    },

    getStockHistory: async (storeId: string, itemId: string, page: number = 0, size: number = 10): Promise<StockHistoryResponse> => {
        const response = await axios.get(`${ENDPOINTS.STOCK.STOCK_HISTORY(storeId, itemId)}?page=${page}&size=${size}`);
        return response.data;
    },

    getLots: async (storeId: string, itemId: string): Promise<StockLot[]> => {
        const response = await axios.get(`${ENDPOINTS.STOCK.LOTS(storeId, itemId)}`);
        return response.data;
    },

    // value=null clears the level (the backend param is optional); a cleared level drops the row
    // off Low Stock, which only lists rows with a level set.
    setReorderLevel: async (stockId: string, value: number | null): Promise<Stock> => {
        const response = await axios.patch(ENDPOINTS.STOCK.REORDER_LEVEL(stockId), null,
            { params: value === null ? {} : { value } });
        return response.data;
    },

    getLowStock: async (institutionId: string): Promise<Stock[]> => {
        const response = await axios.get(ENDPOINTS.STOCK.LOW_STOCK(institutionId));
        return response.data;
    },
};
